module.exports = __webpack_public_path__ + "static/media/HOUSETRAINED.2cc4a5a3.svg";